export default "__VITE_ASSET__BFI9GySt__"